import { useDispatch, useSelector } from 'react-redux';
import { selectConfiguration } from '../ducks/we-spin-selectors';
import { useEffect } from 'react';
import { hydrateConfiguration } from '../ducks/we-spin-duck';

const WeSpinConfiguration = () => {
	const dispatch = useDispatch();
	const configuration = useSelector(selectConfiguration);

	useEffect(() => {
		if (!configuration) dispatch(hydrateConfiguration());
	}, [dispatch, configuration]);

	return false;
};

export default WeSpinConfiguration;
